export const LOADING_EQUIPMENT = "LOADING_EQUIPMENT";
export const GET_EQUIPMENT_LIST = "GET_EQUIPMENT_LIST";
export const REMOVE_EQUIPMENT = "REMOVE_EQUIPMENT";
export const ADD_EQUIPMENT = "ADD_EQUIPMENT";
export const UPDATE_EQUIPMENT = "UPDATE_EQUIPMENT";
export const GET_EQUIPMENT_DOCUMENT_LIST = "GET_EQUIPMENT_DOCUMENT_LIST";
export const LOADING_EQUIPMENT_DOCUMENT = "LOADING_EQUIPMENT_DOCUMENT";
export const REMOVE_EQUIPMENT_DOCUMENT = "REMOVE_EQUIPMENT_DOCUMENT";